import React, { Component } from 'react'
import { ControlSelect } from '../forms/Controls'
import './RowView.css'

class RowView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      groupId: ''
    }
    this.handleOption = this.handleOption.bind(this)
  }
  handleOption (ev) {
    ev.preventDefault()
    this.setState({
      groupId: ev.target.value
    })
    this.props.history.push('/view/' + this.props.id + '/' + ev.target.value)
  }
  render () {
    return (
      <div className='row_view'>
        <div className='row_view__data'>
          <h4 className='row_view__title'>{this.props.fecha}</h4>
          <p className='row_view__meta'>
            {this.props.activa ? <span className='active'>Activa</span> : <span>Cerrada</span>}
            {this.props.actual ? <span className='current'>Actual</span> : null}
          </p>
        </div>
        <div className='row_view__actions'>
          <ControlSelect
            value={this.state.groupId}
            placeholder='Selecciona el grupo a consultar'
            options={this.props.options}
            onChange={this.handleOption}
          />
        </div>
      </div>
    )
  }
}

export default RowView
